import createAssetFromClick from '../util/createAssetFromClick';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import type { ActionSource } from 'owa-timestream-store';
import * as React from 'react';

export function useCreateAssetCallback(
    assetDescriptor: AssetDescriptor,
    actionSource: ActionSource
) {
    return {
        onClick: React.useCallback(
            (e: React.MouseEvent<Element> | React.KeyboardEvent<Element>) => {
                createAssetFromClick(e, assetDescriptor, actionSource);
            },
            [assetDescriptor, actionSource]
        ),
    };
}
